import React from "react";
import { Icon } from "../core/Icon.jsx";

export function SearchField({ value = "", placeholder = "Suchen …", onChange, height, showEsc = true, borderless = false, style = {} }) {
  const h = height || 30;
  return (
    <span style={{
      display: "flex", alignItems: "center", gap: 8, height: h, padding: "0 10px",
      background: borderless ? "transparent" : "var(--bg-field)",
      border: borderless ? "none" : "1px solid var(--line-d)",
      borderRadius: borderless ? 0 : "var(--r-tile)", ...style,
    }}>
      <Icon name="search" size={14} style={{ color: "var(--fg-8)" }} />
      <input value={value} placeholder={placeholder} onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        style={{ flex: 1, minWidth: 0, background: "transparent", border: "none", outline: "none", color: "var(--fg-1)", fontFamily: "inherit", fontSize: "var(--type-value-size)" }} />
      {showEsc ? <span className="esc-chip">esc</span> : null}
    </span>
  );
}
